import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const DonotChart = ({ COLORS }) => {
  const data = [
    { name: "English", value: 400 },
    { name: "Maths", value: 300 }, 
    { name: "Biology", value: 300 },
    { name: "Physics", value: 200 }
  ];
  const percentage = 85;

  return (
    <ResponsiveContainer>
      <PieChart height={400} width={400}>
        <Pie
          data={data}
          // cx={50}
          // cy={80}
          innerRadius={40}
          outerRadius={60}
          fill="#8884d8"
          dataKey="value"
        >
          {data.map((_, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
      <h4 className="donotPercentage">{percentage}%</h4>
    </ResponsiveContainer>
  );
};

export default DonotChart;
